module.exports = __webpack_public_path__ + "img/banner-1-m.36b2c9b9.jpg";